import { FC } from 'react';
import { UpdatePassword } from './UpdatePassword/UpdatePassword';

export const UpdatePasswordPage: FC = () => {
  return <UpdatePassword />;
};
